import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import div from '@mui/material/Paper';
import clsx from 'clsx';
import { obsStatuses } from '../obsUtils';
import config from '../../../../../app/config';
import AgyleButton from '../../../../../components/ui/buttons/agyleButton';
import { RestartAlt } from '@mui/icons-material';
import AgyleBlockSwitch from '../../../../../components/ui/switch/agyleBlockSwitch';
import _ from 'lodash';
import { useTheme } from '@mui/material/styles';
import { isSpecialSmallDeviceDetect } from '../../../../../util/isSpecialSmallDeviceDetect';

const checkObsStatus = (status) => status === 'new' || status === 'completed';

function RenderAcceptSection({
    classes,
    t,
    hideScore,
    score,
    status,
    renderScore,
    onStatusChange,
    resetObs,
    accepted,
    acceptObs,
    acceptDate,
    acceptDisabled = false,
    showStatusNR = false,
    hideStatuses = false,
    disableAcceptButtons = false,
    customButtons = [],
}) {
    const theme = useTheme();
    const isSmallDevice = isSpecialSmallDeviceDetect();

    const [neuroClass, setNeuroClass] = useState(null);
    const renderScoreClass = renderScore ? renderScore?.props?.className : null;

    useEffect(() => {
        if (renderScoreClass) {
            if (_.isString(renderScoreClass)) {
                setNeuroClass(renderScoreClass.split(' ')[1]);
            }
        }
    }, [renderScoreClass]);
    return (
        <Grid item xs={12}>
            <div className={clsx(classes.divRow, isSmallDevice && 'mobile')}>
                <div style={{ minWidth: isSmallDevice ? 50 : 100, marginRight: isSmallDevice ? 5 : 25 }}>
                    {!hideScore && status !== obsStatuses.new && (
                        <div className={clsx(classes.scoreRoot, !renderScore ? `score${score}` : neuroClass)}>
                            <div className={classes.scoreLabel}>{t('Score')}:</div>

                            {renderScore || (
                                <div className={clsx([classes.scoreBadge, `score${score}`])}>
                                    {(status === obsStatuses.new || status === obsStatuses.completed) && score}
                                    {status === obsStatuses.patientCondition && score + '+'}
                                    {status === obsStatuses.notRecorded && 'NR'}
                                    {status === obsStatuses.patientRefused && 'PR'}
                                    {status === obsStatuses.equipment && 'EQ'}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div>
                    {!hideStatuses && (
                        <AgyleBlockSwitch
                            onChange={(val) => onStatusChange(val)}
                            value={status}
                            nullState
                            fourCases
                            tooltipObject={{
                                true: t('Not Recorded: Observation not recorded'),
                                null: t('Patient Refused: Patient declined the observation'),
                                false: t('Patient Condition: Observation not taken due to patient’s clinical condition'),
                                alt: t('Equipment Issue: Observation not taken due to equipment problem'),
                            }}
                            customLabels={{
                                yes: t('NR'),
                                empty: t('PR'),
                                no: t('PC'),
                                alternative: t('EQ'),
                            }}
                            valueObject={{
                                true: obsStatuses.notRecorded,
                                null: obsStatuses.patientRefused,
                                alt: obsStatuses.equipment,
                                false: obsStatuses.patientCondition,
                            }}
                            disabledState={{
                                true: !showStatusNR,
                            }}
                            style={{
                                backgroundColor: theme.palette.mode === 'light' ? '#eff1f3' : '#494b4c',
                            }}
                        />
                    )}
                </div>

                <div className={classes.divRow} style={{ marginLeft: isSmallDevice ? '' : 'auto' }}>
                    {customButtons.map((btn) => btn)}

                    <AgyleButton fullWidth variant="outlined" onClick={() => resetObs(true)} startIcon={<RestartAlt />} colour="primary">
                        {t('Reset')}
                    </AgyleButton>

                    {!disableAcceptButtons && (
                        <div className={classes.acceptButton}>
                            {!accepted && (
                                <AgyleButton
                                    fullWidth
                                    width="100%"
                                    variant="outlined"
                                    onClick={acceptObs}
                                    colour="primary"
                                    disabled={acceptDisabled && checkObsStatus(status)}
                                >
                                    {t('Accept')}
                                </AgyleButton>
                            )}

                            {accepted && (
                                <div className={classes.acceptDate}>
                                    {t('Accepted') + ': ' + acceptDate.format(config.defaultDateTimeFormat)}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Grid>
    );
}

export default RenderAcceptSection;
